/* theme.js — Orthodox Icons Theme */

(function() {
  'use strict';

  /* ─── Cart Drawer ─── */
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartOverlay  = cartDrawer?.querySelector('.cart-drawer__overlay');
  const cartClose    = cartDrawer?.querySelector('.cart-drawer__close');
  const cartBody     = document.getElementById('cart-drawer-body');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  document.querySelectorAll('[data-cart-open]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCart(); });
  });

  /* ─── Fetch & render cart ─── */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(() => {
        if (cartBody) cartBody.innerHTML = '<p style="text-align:center;padding:2rem;font-family:var(--font-accent);font-style:italic;color:var(--smoke);">Unable to load cart.</p>';
      });
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = `
        <div style="text-align:center;padding:3rem 1rem;">
          <p style="font-family:var(--font-accent);font-style:italic;color:var(--smoke);margin-bottom:1.5rem;">Your selection is empty.</p>
          <a href="/collections/all" class="btn btn--dark" onclick="closeCart()">Browse Icons</a>
        </div>`;
      return;
    }
    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__img" src="${item.image}" alt="${item.title}">
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_price)}</div>
          <button class="cart-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    cartBody.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => removeFromCart(btn.dataset.key));
    });

    // Update footer subtotal
    const footer = cartDrawer.querySelector('.cart-drawer__footer');
    if (footer) {
      footer.innerHTML = `
        <div style="display:flex;justify-content:space-between;margin-bottom:1rem;font-family:var(--font-heading);font-size:0.85rem;letter-spacing:0.08em;text-transform:uppercase;">
          <span>Subtotal</span><span>${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/cart" class="btn btn--primary btn--full">Proceed to Checkout</a>
      `;
    }
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(() => { fetchCart(); updateCartCount(); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ─── Add to Cart ─── */
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }] })
    })
    .then(r => r.json())
    .then(() => {
      if (btn) { btn.disabled = false; btn.textContent = 'Added'; setTimeout(() => { btn.textContent = 'Add to Collection'; }, 2000); }
      updateCartCount();
      openCart();
    })
    .catch(() => {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Collection'; }
    });
  });

  /* Quick add buttons on collection grid */
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', function() {
      const variantId = this.dataset.quickAdd;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(() => { updateCartCount(); openCart(); });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ─── Product Gallery ─── */
  const thumbs    = document.querySelectorAll('.product-gallery__thumb');
  const mainImg   = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) mainImg.src = this.querySelector('img').src.replace('_80x100', '_800x');
    });
  });

  /* ─── Accordion ─── */
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const item = this.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ─── Variant Selection ─── */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      this.closest('.variant-options').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const form = document.querySelector('[data-product-form]');
      if (form) form.querySelector('[name="id"]').value = this.dataset.variantId;
    });
  });

  /* ─── Mobile menu toggle ─── */
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const siteNav   = document.querySelector('.site-nav');
  if (mobileBtn && siteNav) {
    mobileBtn.addEventListener('click', () => {
      const isOpen = siteNav.style.display === 'flex';
      siteNav.style.display = isOpen ? '' : 'flex';
      siteNav.style.flexDirection = 'column';
      siteNav.style.position = 'absolute';
      siteNav.style.top = '80px';
      siteNav.style.left = '0';
      siteNav.style.right = '0';
      siteNav.style.background = 'var(--ink)';
      siteNav.style.padding = '1rem var(--gutter)';
      siteNav.style.borderBottom = '1px solid rgba(201,165,90,0.3)';
    });
  }

  /* ─── Init cart count on load ─── */
  updateCartCount();

})();
